const ReadyToUseSection = () => {
  return (
    <section id="ready-to-use" className="mt-20 px-5 sm:px-10 xl:px-20">
      <div>
        <h3 className="space-x-2 text-center text-4xl md:text-5xl lg:text-6xl">
          <span className="font-worksans  text-[#D2D2D2]">Ready to</span>
          <span className="font-worksans  bg-gradient-to-r from-[#30C67C] to-[#17730A] bg-clip-text text-transparent">
            Use the Fez Safe Locker?
          </span>
        </h3>
        <div className="mt-10 ">
          <img
            src="images/locker2.svg"
            alt="safe-locker"
            className="w-full object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default ReadyToUseSection;
